/** @format */

import React, { useState, useContext } from "react";

//router
import { Link, useLocation } from "react-router-dom";

//react-bootstrap
import {
  Accordion,
  useAccordionButton,
  AccordionContext,
  Nav,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";

const VerticalNav = React.memo(() => {
  //location
  let location = useLocation();
  // console.log(document);

  return (
    <React.Fragment>
      <Accordion as="ul" className="navbar-nav iq-main-menu" id="sidebar-menu">
        <li className="nav-item static-item">
          <Link className="nav-link static-item disabled" to="#" tabIndex="-1">
            <span className="default-icon">Main</span>
            <span
              className="mini-icon"
              data-bs-toggle="tooltip"
              title="Social"
              data-bs-placement="right"
            >
              -
            </span>
          </Link>
        </li>
        <li
          className={`${location.pathname === "/" ? "active" : ""} nav-item `}
        >
          <Link
            className={`${location.pathname === "/" ? "active" : ""} nav-link `}
            aria-current="page"
            to="/e/dashboard"
          >
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Dashboard</Tooltip>}
            >
              <i className="icon material-symbols-outlined">dashboard</i>
            </OverlayTrigger>
            <span className="item-name">Dashboard</span>
          </Link>
        </li>
        <li
          className={`${location.pathname === "/" ? "active" : ""} nav-item `}
        >
          <Link
            className={`${location.pathname === "/" ? "active" : ""} nav-link `}
            aria-current="page"
            to="/e/joblisting"
          >
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Dashboard</Tooltip>}
            >
              <i className="icon material-symbols-outlined">work</i>
            </OverlayTrigger>
            <span className="item-name">Job Listing</span>
          </Link>
        </li>
        <li
          className={`${location.pathname === "/" ? "active" : ""} nav-item `}
        >
          <Link
            className={`${location.pathname === "/" ? "active" : ""} nav-link `}
            aria-current="page"
            to="/e/myprofile"
          >
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Dashboard</Tooltip>}
            >
              <i className="icon material-symbols-outlined">Person</i>
            </OverlayTrigger>
            <span className="item-name">My Profile</span>
          </Link>
        </li>
        <Nav.Item
          as="li"
          className={`${location.pathname === "/" ? "active" : ""} nav-item `}
        >
          <Link
            className={`${location.pathname === "/" ? "active" : ""} nav-link `}
            aria-current="page"
            to="/e/candidate"
          >
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Candidate Searching</Tooltip>}
            >
              <i className="icon material-symbols-outlined">person_search</i>
            </OverlayTrigger>
            <span className="item-name">Candidate Searching</span>
          </Link>
        </Nav.Item>
        <Nav.Item as="li">
          <Link
            className={`${location.pathname === "/" ? "active" : ""} nav-link `}
            aria-current="page"
            to="/e/setting"
          >
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Settings</Tooltip>}
            >
              <i className="icon material-symbols-outlined">settings</i>
            </OverlayTrigger>
            <span className="item-name">Settings</span>
          </Link>
        </Nav.Item>
      </Accordion>
    </React.Fragment>
  );
});

export default VerticalNav;
